(() => {
  const form = document.getElementById('BukeLocalizationForm');
  const select = document.getElementById('BukeLocaleSelect');
  if (!form || !select || select.options.length < 2) return;
  const key = 'buke-language-choice';
  select.addEventListener('change', () => {
    window.localStorage.setItem(key, 'manual');
    form.submit();
  });
  if (window.localStorage.getItem(key)) return;
  const preferred = (navigator.languages || [navigator.language])
    .map((locale) => String(locale || '').toLowerCase());
  const option = [...select.options].find((item) => preferred.some((locale) => locale === item.value.toLowerCase() || locale.startsWith(`${item.value.toLowerCase()}-`)));
  if (option && option.value !== select.value) {
    select.value = option.value;
    form.submit();
  }
})();
